function swipeHorizontal(startX, endX, threshold = 50) {
  const delta = endX - startX;
  if (delta > threshold) return "right";
  if (delta < -threshold) return "left";
  return null;
}

module.exports = { swipeHorizontal };
